import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'

import errors from '../../lib/errors.js'
import UserCard from './UserCard'
import UserNotFound from './UserNotFound'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const UserStore = Resource('users')


class ShowUserPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    UserStore.find(this.props.match.params.id)
    .then((result) => this.setState({user: result.data, loading: false}))
    .catch((error) => this.setState({user: {}, error: errors.unpack(error), loading: false}))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      user,
      redirect,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={this.state.redirect}/>
    if (isEmpty(user)) return <UserNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            User
          </PageTitle>
        </header>
        <UserCard
          user={user}
          editCallback={() => this._redirectTo(`/users/${user.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowUserPage



// WEBPACK FOOTER //
// ./src/components/Users/ShowUserPage.jsx